import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgxPopupComponent } from '../../ngx-popups/ngx-popups/components/popup.component';
import { NavigationStep } from '../../digitization-top-nav/navigation-stepper/navigation-stepper.component';

@Component({
    selector: 'app-step-navigation-warning',
    templateUrl: './step-navigation-warning.component.html',
    styleUrls: ['./step-navigation-warning.component.scss'],
    standalone: false
})
export class StepNavigationWarningComponent {
  @Input() popup: NgxPopupComponent;
  @Input() steps: NavigationStep[] = [];
  @Input() currentStepIndex: number;
  @Input() targetStepIndex: number;
  
  @Output() callback = new EventEmitter<boolean>();

  answer(confirmed: boolean) {
    this.callback.emit(confirmed);
    this.popup.close(true, confirmed);
  }

  getStepStatus(index: number): 'completed' | 'current' | 'pending' {
    if (index < this.currentStepIndex) {
      return 'completed';
    } else if (index === this.currentStepIndex) {
      return 'current';
    } else {
      return 'pending';
    }
  }
}

